import React, { useState, useEffect } from "react";
import ScrollableContainer from "../../Scrollbar";
import { FunnelIcon } from "@heroicons/react/24/outline";
import { useTheme } from "../../../ThemeContext";

const Sidebar = ({ uniqueStructures, setSelectedStructure }) => {
  const { theme } = useTheme();
  const isDark = theme === "dark";

  // Set selected items to all structures by default
  const [selectedItems, setSelectedItems] = useState([]);

  // Update selectedItems when uniqueStructures changes
  useEffect(() => {
    setSelectedItems(uniqueStructures); // Select all structures when uniqueStructures updates
  }, [uniqueStructures]);

  useEffect(() => {
    setSelectedStructure(selectedItems); // Update parent with selected items
  }, [selectedItems, setSelectedStructure]);

  // Handle toggling selection for an item
  const handleToggleSelection = (item) => {
    setSelectedItems((prev) =>
      prev.includes(item)
        ? prev.filter((i) => i !== item) // Deselect if already selected
        : [...prev, item] // Add to selection if not already selected
    );
  };

  // Select all items
  const handleSelectAll = () => {
    setSelectedItems(uniqueStructures); // Select all items
  };

  // Deselect all items
  const handleUnselectAll = () => {
    setSelectedItems([]); // Deselect all items
  };

  // console.log(selectedItems); // Debugging the state
  const isAllSelected = selectedItems.length === uniqueStructures.length;
  // console.log(isAllSelected); // Debugging the all-selected check

  return (
    <ScrollableContainer
      className={`p-4 w-64 space-y-4 ${isDark ? "bg-gray-800 text-white" : "bg-gray-100 text-black"}`}
    >
      {/* Header with Select All / Unselect All Options */}
      <div className="flex justify-between relative items-center">
        <div className="flex space-x-2">
          <button
            className={`py-2 px-4 rounded ${isDark ? "bg-blue-500 text-white" : "bg-blue-400 text-white"}`}
            onClick={isAllSelected ? handleUnselectAll : handleSelectAll}
            disabled={uniqueStructures.length === 0} // Disable if no structures are available
          >
            {isAllSelected ? "Unselect All" : "Select All"}
          </button>
        </div>
      </div>

      {/* List of Items with Checkboxes */}
      {uniqueStructures.map((item, index) => (
        <div
          key={index}
          className={`flex items-center space-x-2 py-2 px-4 rounded ${isDark ? "bg-gray-700 hover:bg-blue-500" : "bg-gray-300 hover:bg-blue-400"} transition`}
        >
          <input
            type="checkbox"
            checked={selectedItems.includes(item)}
            onChange={() => handleToggleSelection(item)}
            className="form-checkbox"
          />
          <label className="cursor-pointer">{item}</label>
        </div>
      ))}
    </ScrollableContainer>
  );
};

export default Sidebar;
